import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ButtonIconComponent} from "../button-icon/button-icon.component";
import {OverlayRef} from "@angular/cdk/overlay";

@Component({
  selector: 'app-modal-title',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonIconComponent,
  ],
  templateUrl: './modal-title.component.html',
  styleUrl: './modal-title.component.scss'
})
export class ModalTitleComponent {
  constructor(private overlayRef: OverlayRef) {}

  close() {
    this.overlayRef.dispose();
  }
}
